import { TableDataSource } from 'common/table/table-data-source';
import { AggregatedProductRevision, ViewService } from 'api';
import { inject } from '@angular/core';
import { PagedResult, PageLoadParams } from 'common/table/paged-result.interface';
import { Observable } from 'rxjs';

export class RecentlyUsedRevisionsDataSource extends TableDataSource<AggregatedProductRevision> {
  private viewService = inject(ViewService);

  protected fetchPage(
    pageLoadParams: PageLoadParams,
  ): Observable<PagedResult<AggregatedProductRevision>> {
    return this.viewService.getRecentlyUsedAggregatedProductRevisions(
      0,
      pageLoadParams.page,
      pageLoadParams.pageSize,
    );
  }

  async deleteByIds(_ids: number[]): Promise<void> {}
}
